import { Component, ViewEncapsulation } from '@angular/core';
import { ModalService } from './modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent {

  constructor(
    private modalService: ModalService
  ) { }

  public closeModal() {
    this.modalService.closeModal(false);
  }
}
